import { createI18n } from 'vue-i18n'
import enUS from '@widgets/shared/locales/en_US.json'
import { numberFormats } from '@/config/formatting'

const defaultLocale = 'en-US'

export default createI18n<[typeof enUS], 'en-US'>({
  numberFormats,
  legacy: true,
  globalInjection: false,
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  messages: enUS as any,
  silentFallbackWarn: true,
})
